import { isScheduleActive, getNextActiveTime, getInactiveTime } from 'utils/scheduling';
import { convertDateToVenueTimezone } from 'utils/date';
import { serverNow } from 'utils/serverTime';

// getNextActiveTime/getInactiveTime return `false` when there's no boundary;
// coerce non-numbers to null so downstream `=== null` checks behave.
const toMs = val => {
  if (val instanceof Date) return val.getTime();
  return typeof val === 'number' ? val : null;
};

export const venueCurrentTime = venueTimezone => {
  const now = serverNow();
  return venueTimezone ? convertDateToVenueTimezone(now, venueTimezone) : now;
};

// null/missing schedule is treated as always-active.
export const evaluateSchedule = (schedule, currentTime) => {
  if (!schedule) return { active: true, nextActiveTime: null, nextInactiveTime: null };
  const active = isScheduleActive(schedule, currentTime);
  return {
    active,
    nextActiveTime: active ? null : toMs(getNextActiveTime(schedule, currentTime)),
    nextInactiveTime: active ? toMs(getInactiveTime(schedule, currentTime)) : null,
  };
};

export const scheduleNextBoundary = (schedule, currentTime) => {
  const { active, nextActiveTime, nextInactiveTime } = evaluateSchedule(schedule, currentTime);
  return active ? nextInactiveTime : nextActiveTime;
};

export const findScheduleById = (schedules, scheduleId) => {
  if (!schedules || scheduleId === null || typeof scheduleId === 'undefined') return null;
  return schedules.find(s => Number(s.get('id')) === Number(scheduleId)) || null;
};
